<template>
    <div>
        <button aria-label="Tipo" @click="toggle" :class="filter_elements.length>0?'selected':''" :disabled="!especieId">
            <span>{{ selected ? selected.value : 'Tipo' }}</span>
            <span class="filter_icon">
                <i v-if="!active" class="fas fa-angle-down"></i>
                <i v-else class="fas fa-angle-up"></i>
            </span>
        </button>
        <div v-if="active" v-click-outside="toggle">
            <div class="options_filters_container">
                <div class="options_head">
                    <div class="input_search">
                        <label>
                            <div>
                                <input aria-label="Buscar tipo" placeholder="Buscar tipo" type="text" v-model="filter_key" @keyup="filterItems()">
                            </div>
                        </label>
                    </div>
                    <span class="icon_search">
                        <span>
                            <i class="fa fa-search"></i>
                        </span>
                    </span>
                </div>
                <div class="options_body">
                    <div class="contain">
                        <div v-if="!items.length">
                            <load-spiner></load-spiner>
                        </div>
                        <div v-else class="options_item">
                            <div v-if="filter_items_list.length>0||filter_key" class="item">
                                <li v-for="item in filter_items_list" @click="setFilter(item)" :class="filter_elements.includes(item)?'check':''">
                                    <span>
                                        {{item.value}}
                                    </span>
                                    <div class="checkmark">
                                    </div>
                                </li>
                            </div>
                            <div v-else class="item">
                                <li v-for="item in items" @click="setFilter(item)" :class="filter_elements.includes(item)?'check':''">
                                    <span>
                                        {{item.value}}
                                    </span>
                                    <div class="checkmark">
                                    </div>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="filter_elements.length>0" class="options_footer" @click="deleteFilter()">
                    <button class="restart_button">
                        Restablecer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            especieId: {
                default: null
            },
            value: {
                default: null
            }
        },
        data() {
            return {
                tipos: [],
                filter_elements: [],
                filter_key: "",
                filter_items_list: [],
                active: false,
            }
        },
        computed: {
            items() {
                return this.tipos.map(e => {
                    return {
                        id: e.id,
                        value: e.nombre
                    }
                })
            },
            selected() {
                let selected = null;
                if (this.filter_elements.length) {
                    selected = this.filter_elements[0];
                }
                return selected;
            }
        },
        mounted() {
            this.getItems();
        },
        watch: {
            especieId(oldValue, newValue) {
                if (oldValue !== newValue) {
                    this.getItems();
                    this.filter_elements = [];
                    this.notifyValue();
                }
            },
            value() {
                this.setItemByValue();
            }
        },
        methods: {
            filterItems: function() {
                this.filter_items_list = this.items.filter(item => item.value.toUpperCase().includes(this.filter_key.toUpperCase()));
            },
            getItems: function () {
                let vm = this;
                if (!this.especieId) {
                    return;
                }
                let params = {
                    'tipo-filter': 1,
                    'especie_id': this.especieId,
                };
                axios.get(this.route('custom.variety-select-info'), {
                    params
                }).then(response => {
                    let data = response.data;
                    let tipos = data.motes;
                    if (!tipos) {
                        tipos = [];
                    }
                    vm.tipos = tipos;
                    this.setItemByValue();
                }).catch(e => {
                    console.error(e);
                });
            },
            toggle: function () {
                this.$root.$emit('toggleFilterProducts' , this, this.active);
            },
            setFilter: function (item) {
                var index = this.filter_elements.indexOf(item);
                if (index < 0) {
                    this.filter_elements = [item];
                } else {
                    this.filter_elements = [];
                }
                this.notifyValue();
                this.toggle();
            },
            notifyValue() {
                let value = null;
                let selected = this.selected;
                if (selected) {
                    value = selected.id;
                }
                this.$emit('input', value);
            },
            deleteFilter: function () {
                this.filter_elements = [];
                this.notifyValue();
            },
            setItemByValue() {
                if (this.value) {
                    let item = this.items.find(e => e.id === this.value);
                    if (item) {
                        this.filter_elements = [item];
                    } else {
                        this.filter_elements = [];
                        this.notifyValue();
                    }
                }
            }
        }
    }
</script>

<style scoped>
    button {
        position: relative;
        cursor: pointer;
        padding: 7px 12px;
        line-height: 1;
        letter-spacing: 0.5px;
        background-color: white;
        color: #1a1a1a;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid #ddd;
        border-radius: 4px;
        -webkit-appearance: button;
        overflow: visible;
        text-transform: capitalize;
    }

    button:disabled {
        color: #8c8c8c;
        background-color: #fafafa;
    }

    button:disabled i {
        color: #8c8c8c;
    }

    button:hover {
        background: #f3f3f3;
    }

    button .filter_icon {
        padding-left: 8px;
        font-weight: 700;
        color: #1a1a1a;
        display: inline-block;
        vertical-align: middle;
        position: relative;
    }

    .options_filters_container {
        width: 288px;
        position: absolute;
        border: 1px solid #ddd;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
        margin-top: 8px;
        background: white;
        border-radius: 4px;
        z-index: 9999;
    }

    .options_filters_container .options_body {
        min-height: 0;
        height: 350px;
        overflow-y: hidden;
        overflow-x: hidden;
        max-height: 40vh;
        padding: 0 0 16px 16px;
        margin-top: 16px;
        color: #1a1a1a;
        transform: translateZ(0);
    }

    .options_filters_container .options_body .contain {
        overflow: auto;
        will-change: transform;
        height: 100%;
        width: 100%;
    }

    .options_filters_container .options_body .contain .options_item {
        position: relative;
        width: 100%;
        min-height: 100%;
        height: auto;
    }

    .options_filters_container .options_body .contain .options_item .item {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 40px;
    }

    .options_filters_container .options_body .contain .options_item .item li {
        text-transform: none;
        margin-bottom: 8px;
        margin-right: 16px;
        border: 1px solid #ddd;
        position: relative;
        display: flex;
        align-items: center;
        height: 32px;
        cursor: pointer;
        list-style-type: none;
        padding: 0;
        border-radius: 4px;
    }

    .options_filters_container .options_body .contain .options_item .item li span {
        margin-left: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .options_filters_container .options_footer {
        display: flex;
        justify-content: flex-end;
        padding: 8px 16px;
        border-top: 1px solid #ddd;
    }

    .options_filters_container .options_footer .restart_button {
        background: white;
        text-align: right;
        margin-right: 8px;
        white-space: nowrap;
        height: 40px;
        padding: 0 12px;
        line-height: 40px;
        font-weight: 700;
        color: #1a1a1a;
    }

    .options_filters_container .options_body .contain .options_item .item li.check {
        font-weight: bold;
        border-color: black;
    }

    button.selected {
        border-color: #1a1a1a;
        font-weight: bold;
    }

    .options_filters_container .options_body .contain .options_item .item li div {
        width: 30px;
        height: 100%;
        position: relative;
        margin-left: auto;
    }

    .options_filters_container .options_body .contain .options_item .item li.check .checkmark:after {
        content: "";
        position: absolute;
        width: 12px;
        height: 7px;
        top: 10px;
        right: 8px;
        border: 1px solid #1a1a1a;
        border-top: none;
        border-right: none;
        transform: rotate(-52deg);
    }

    .options_filters_container .options_head {
        height: 36px;
        padding: 0 16px;
        margin-top: 16px;
        position: relative;
        display: flex;
        align-items: center;
        background: white;
    }

    .options_filters_container .options_head .input_search {
        background-color: white;
        border: 0;
        box-sizing: border-box;
        color: #1a1a1a;
        display: inline-block;
        position: relative;
        outline: 0;
        padding: 0;
        width: 100%;
        transition: box-shadow 0.25s;
        height: 100%;
        flex: 1;
    }

    .options_filters_container .options_head .input_search label {
        -webkit-tap-highlight-color: transparent;
        display: initial;
    }

    .container_filter .options_filters_container .options_head .input_search label div {
        height: 100%;
    }

    .options_filters_container .options_head .input_search label div input {
        height: 100%;
        padding: 0 0 0 38px;
        font-size: 16px;
        box-shadow: none;
        color: #1a1a1a;
        border-radius: 4px;
        background: #f3f3f3;
        letter-spacing: 0.5px;
        box-sizing: border-box;
        display: block;
        line-height: 18px;
        margin: 0;
        outline: none;
        position: relative;
        vertical-align: baseline;
        width: 100%;
        -webkit-appearance: none;
        text-transform: none;
        border: 0;
        transition: box-shadow 0.25s ease;
    }

    .options_filters_container .options_head .icon_search {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }

    .options_filters_container .options_head .icon_search span {
        color: #1a1a1a;
        margin: -2px 0 -1px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        padding: 7px;
    }

    .options_filters_container .options_body .contain::-webkit-scrollbar {
        width: 8px;
    }

    .options_filters_container .options_body .contain::-webkit-scrollbar-thumb {
        background: #1a1a1a;
        border-radius: 8px;
    }


</style>
